<template>
	<PopupRouterView :showLeftIcon="true" label="Job Configuration Input"  entityName="jobconfiguration" :documentId="mainRecordId"  @saveMethod="saveActionConfirmation" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-interface-name" label-cols-sm="4" label-cols-lg="3" label="Interface Name" label-for="input-interface-name" size="sm" :model.sync="model.interfaceName"   />
				<app-input-textbox id="fieldset-job-name" label-cols-sm="4" label-cols-lg="3" label="Job Name" label-for="input-job-name" size="sm" :model.sync="model.jobName"   />
				<app-input-textarea id="fieldset-job-description" label-cols-sm="4" label-cols-lg="3" label="Job Description" label-for="input-job-description" size="sm" :model.sync="model.jobDescription"   />
				<b-form-group id="fieldset-is-stored-procedure" label-cols-sm="4" label-cols-lg="3" label="Is Stored Procedure" label-for="input-is-stored-procedure">
						<b-form-checkbox id="input-is-stored-procedure" v-model="model.isStoredProcedure"  ></b-form-checkbox>
					</b-form-group>
			</b-col>
			<b-col>
				<span class="float-right" v-if="modelId != null && modelId != undefined && modelId != ''">
					<b-button variant="success" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</span>
			</b-col>
		</b-card>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :model="model" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import JobConfiguration from '@/models/JobConfiguration/JobConfiguration';
import JobConfigurationList from '@/models/JobConfiguration/JobConfigurationList';
import JobConfigurationFilter from '@/filters/JobConfiguration/JobConfigurationFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,AppInputTextarea,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterJobConfiguration : null,
			currentJobConfigurationPage : 1,
			jobConfigurationPageSize: 10,
			sortByJobConfiguration: '',
			sortDescJobConfiguration: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getJobConfiguration : async function(id) {
			this.isBusy = true;
			JobConfiguration.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadJobConfiguration = true;
			this.filterJobConfiguration.id = this.modelId;
			JobConfiguration.downloadDataDetail(this, this.filterJobConfiguration).then(result => {
				this.isDownloadJobConfiguration = false;
			}).catch(error => { this.isDownloadJobConfiguration = false; })
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				JobConfiguration.updateData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'jobconfigurationindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			} else {
				JobConfiguration.insertData(this, model).then(result => {
					this.$router.push({ name: 'jobconfigurationindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		onHidden() {
			this.getJobConfigurations();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterJobConfiguration = new JobConfigurationFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getJobConfiguration(id);
			} else {
				this.modelId = id;
				this.getJobConfiguration(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
	},
}
</script>
